module.exports = __webpack_public_path__ + "static/media/application.a9a9a8a8.jpg";